import { FlaskConical } from 'lucide-react'
import { ENV_LABEL } from '@/lib/app-env'
import { cn } from '@/lib/cn'

/**
 * "You are not on production" chip. Renders nothing on the `main` build —
 * ENV_LABEL is null there — so this is safe to drop anywhere in the shell and
 * safe to merge into `main`.
 */
export function EnvBadge({ className }: { className?: string }) {
  if (!ENV_LABEL) return null
  return (
    <span
      title={`Non-production build (branch: ${ENV_LABEL.toLowerCase()})`}
      className={cn(
        'inline-flex items-center gap-1 rounded px-1.5 py-0.5',
        'bg-penser-blue/15 text-[10px] font-bold uppercase tracking-wider text-penser-blue-dark',
        className,
      )}
    >
      <FlaskConical size={11} />
      {ENV_LABEL}
    </span>
  )
}
